/**
 * Rust core does the work; `browser/encrypted-toolcall.ts` mirrors it for the
 * browser and must produce the same columns.
 */

import { native } from "./native.js";

/** Must match `column_aad` in the core — the label binds a ciphertext to its column. */
export function columnAad(toolCallId: string, column: string): string {
  return `${toolCallId}:${column}`;
}

/** Byte-identical to the dashboard's copy — diverging breaks hold-retry resolution. */
export function normalizeActionForHash(action: string): string {
  return native.normalizeActionForHash(action);
}

/** Lets the judge check the request body against the ciphertext without an org key. */
export function claimHashHex(
  toolName: string,
  action: string,
  context: string,
  toolArgsJson: string,
): string {
  return native.claimHashHex(toolName, action, context, toolArgsJson);
}

/** @returns hex-encoded signed tx, ready to POST as `signed_log_tool_call`. */
export function signEncryptedToolCall(
  toolCallId: string,
  action: string,
  context: string,
  toolName: string,
  toolArgsJson: string,
  orgEncryptionPubKey: string,
  privkeyHex: string,
  blockchainRidHex: string,
): string {
  return native.signEncryptedToolCall(
    toolCallId,
    action,
    context,
    toolName,
    toolArgsJson,
    orgEncryptionPubKey,
    privkeyHex,
    blockchainRidHex,
  );
}
